// extracted by mini-css-extract-plugin
export var createdDate = "_mq-1";
export var divider = "_mq-2";
export var headerDivider = "_mq-3";
export var messagesCard = "_mq-0";
export var messagesContainer = "_mq-6";
export var messagesContainerWrapper = "_mq-4";
export var showLeftPanelButton = "_mq-8";
export var topButtons = "_mq-7";
export var withPadding = "_mq-5";